'use client'

import { useState } from "react";
import { Accordion } from "@mantine/core";
import { RiAddCircleLine, RiIndeterminateCircleLine } from "@remixicon/react";

const faqs = [
  {
    id:1,
    question: 'What documents are required before check-in?',
    answer:
      'We require a clear photo of valid IDs or passports for all guests prior to check-in. This helps us ensure a smooth and secure check-in process.',
  },
  {
    id:2,
    question: 'Are there any restrictions on group bookings?',
    answer:
      'As per Egyptian law, mixed-gender groups or unmarried couples are only allowed if all guests are non-Arab foreigners.',
  },
  {
    id:3,
    question: 'Can I have visitors during my stay?',
    answer:
      'Visitors are generally not allowed. However, if they are first-degree or second-degree relatives, please contact us in advance for approval.',
  },
  {
    id:4,
    question: 'What time is check-in and check-out?',
    answer:
      'Check-in is from 3:00 PM onwards, and check-out is by 12:00 PM. Early check-in or late check-out may be arranged in advance, subject to availability.',
  },
  {
    id:5,
    question: 'Can I request housekeeping during my stay?',
    answer:
      'Yes! Housekeeping services are available upon request. For longer stays, we offer scheduled cleanings to keep your space fresh and tidy.',
  },
  {
    id:6,
    question: 'Is there a minimum stay requirement?',
    answer:
      'Minimum stay varies by unit and season, but typically ranges from 2 to 3 nights. Details are listed in each property description.',
  },
  {
    id:7,
    question: 'Are pets allowed?',
    answer:
      'At the moment, we do not allow pets in our properties unless stated otherwise in the specific unit’s listing.',
  },
  {
    id:8,
    question: 'What’s your cancellation policy?',
    answer:
      'Cancellation policies may vary depending on the property and timing of the booking. Please refer to the terms shown at checkout or reach out to us if you need clarification.',
  },
  {
    id:9,
    question: 'How do I access the property?',
    answer:
      'Guests can enjoy self check-in and check-out at all our properties. You’ll receive access instructions via email or text prior to check-in.',
  },
  {
    id:10,
    question: 'What amenities are included with my booking?',
    answer:
      'All properties are equipped with basic amenities, such as Wi-Fi, towels, and linens. Additional amenities may vary by property.',
  },
]

function FaqAccordion({ className = '' }) {
  const [openItem, setOpenItem] = useState("1");

  return (
    <div
      className={
        'mx-auto md:mx-0 space-y-4 md:pb-10 pb-4 max-md:px-6' + ' ' + className
      }
      id='faqs'
    >
      <h2 className='text-lg font-semibold text-[#1E1F24] mt-1'>
        Most Asked Questions By Guests
      </h2>
      <div className="py-2 ">
        <Accordion
          chevronSize={0}
          value={openItem}
          onChange={(val) => setOpenItem(val)}
          variant="unstyled"
        >
          {faqs?.map((item) => {
            const isOpen = openItem === String(item.id);
            return (
              <Accordion.Item
                key={item.id}
                value={String(item.id)}
                className={`transition-colors duration-300`}
              >
                <Accordion.Control px={0}>
                  <div className="flex items-center gap-4 md:gap-6">
                    <div className="w-4 h-4 mb-1">
                      {isOpen ? (
                        <RiIndeterminateCircleLine size={20} className="text-[#191919]" />
                      ) : (
                        <RiAddCircleLine size={20} className="text-[#191919]" />
                      )}
                    </div>
                    <span className="text-[#191919] text-sm font-semibold">
                      {item.question}
                    </span>
                  </div>
                </Accordion.Control>
                {item.answer && (
                  <Accordion.Panel className=" pl-4 md:pl-[1.6rem] text-[#898989] text-[13px]">
                    {item.answer}
                  </Accordion.Panel>
                )}
              </Accordion.Item>
            );
          })}
        </Accordion>
      </div>
    </div>
  )
}

export default FaqAccordion
